export const aiSubscriptionId = process.env.REACT_APP_AI_SUBSCRIPTION_ID;
